import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function startSession() {
	const url = `/Notarization/video-session/start`;
	return Auth.GET(url);
}

export function joinSession(sessionId) {
	const url = `/Notarization/video-session/join/${sessionId}`;
	return Auth.GET(url);
}

export function startArchive(sessionId, notarizationId) {
	const url = `/Notarization/video-session/archive/${sessionId}/${notarizationId}`;
	return Auth.GET(url);
}

export function canDownload(notarizationId) {
	const url = `/Notarization/video-session/${notarizationId}/candownload`;
	return Auth.GET(url);
}

export function download(notarizationId) {
	const url = `/Notarization/video-session/${notarizationId}/download`;
	return Auth.GETfile(url);
}